function List({
	elements,
	onClick,
	label = "name",
	cancelElement = false,
	customElement = false,
	mode = 1,
}) {
	return (
		<div className={"list mode-" + mode}>
			{cancelElement && (
				<a className="list-element" onClick={() => onClick(false)}>
					{cancelElement}
				</a>
			)}
			{customElement ? (
				<>{elements && elements.map((el, i) => customElement(el, i))}</>
			) : (
				elements &&
				elements.map((el, i) => (
					<a
						key={i}
						className={"list-element" + (el.license_expired ? " disabled" : "")}
						onClick={() => !el.license_expired && onClick(el)}
					>
						{el[label]}
						{el.license_expired && " (licenza scaduta)"}
					</a>
				))
			)}
		</div>
	);
}

export default List;
